export enum AdvanceState {
    Unfinalised = 'Unfinalised',
    Finalised = 'Finalised'
}
